export default class InsuredName {

	public firstNameOrCompanyName: string | null = null;
	public lastName: string | null = null;

	public constructor() {

	}
};